import { render, staticRenderFns } from "./step.vue?vue&type=template&id=484f9f8f"
import script from "./step.ts?vue&type=script&lang=js&external"
export * from "./step.ts?vue&type=script&lang=js&external"
import style0 from "./step.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports